// src/layouts/Pages/PageHeader/CardHeaderColumns/items/website.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { GlobalOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import appService from 'services/appService';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const websiteItem = record => {
  const website = record?.website?.value || record?.website;

  const handleClick = () => {
    appService.handleCopyToClipboard(website);

    appService.notification({
      flag: 'success',
      icon: <GlobalOutlined />,
      title: 'website_copied',
      description: translateX('open_website_question', { website }),
      noTranslateDescription: true,
      duration: 0,
      actions: [
        { text: 'no', type: 'default' },
        { text: 'yes', type: 'primary', onClick: () => window.open(website, '_blank') },
      ],
    });
  };

  return {
    key: 'website',
    icon: <GlobalOutlined />,
    label: website,
    tooltipText: translateX('website'),
    tooltipPlacement: 'right',
    onClick: website ? handleClick : null,
  };
};

export default websiteItem;
